<script lang="ts">
  import inView from "$lib/utils/inView";
  import { _ } from "svelte-i18n";

  export let galleryId: number;

  let isInView = false;

  export let inverted = false;
  export let padded = false;

  export let title: string;

  import { onMount } from "svelte";
  import { browser } from "$app/environment";
  import Typography from "../Typography/Typography.svelte";
  import Container from "../Container/Container.svelte";

  $: loaded = false;

  let viewportWidth: number;
  let isMobile = false;
  let mdWidth = 768;

  $: isMobile = viewportWidth < mdWidth;

  onMount(() => {
    if (browser) {
      const checkWidget = () => {
        const widget = document.querySelector(".dh-widget-container");
        if (widget && widget.clientHeight > 0) {
          loaded = true;
          return true;
        }
        return false;
      };

      // Check initially
      if (!checkWidget()) {
        // If not found initially, set up a mutation observer to detect when it's added
        const observer = new MutationObserver(() => {
          if (checkWidget()) {
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    }
  });
</script>

<style lang="scss">
  .dash-gallery {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    background-color: $surface;
    opacity: 1 !important;
    transition: opacity 0.5s ease-in-out;

    &--padded {
      padding-top: 2rem;
      padding-bottom: 4rem;
      @include breakpoint(md) {
        padding-top: 4rem;
        padding-bottom: 6rem;
      }
    }

    &--inverted {
      background-color: $on-surface;
    }
  }
  .hidden {
    width: 1px;
    height: 1px;
    padding: 0;
    opacity: 0;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

<span
  use:inView={{
    threshold: 0.1,
  }}
  on:intersect={({ detail }) => {
    if (detail) {
      isInView = true;
    }
  }}
  class={`${loaded ? "dash-gallery" : "hidden"} 
    ${padded ? "dash-gallery--padded" : ""}
    ${inverted ? "dash-gallery--inverted" : ""}
  `}
>
  {#if galleryId && title && loaded}
    <Container>
      <Typography
        theme={inverted ? "inverse-on-surface" : "on-surface"}
        variant={isMobile ? "h2" : "h1"}
        component="h2">{$_(title)}</Typography
      >
    </Container>
  {/if}
  {#if galleryId && isInView}
    <script
      src="https://cdn.dashsocial.com/web/js/board-carousel-embed.js"
      type="text/javascript"
      data-name="dhboard-carousel"
      data-gallery-id={galleryId}
      data-row-size="4"
      data-gap-size="4"
      data-mobile-row-size="2"
      data-autoplay="true"
      data-mobile-gap-size="2"
      data-call-to-action="Shop Now"
    ></script>
  {/if}
</span>
